module.exports = __webpack_public_path__ + "static/img/Icon2.03f7ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon2.png
// module id = CgTY
// module chunks = 7